import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Error' })(theme => ({
  root: {
    padding: 'var(--ebl-s4)',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  content: {
    flexBasis: '50%',
  },
  heading: {
    marginBottom: 'var(--ebl-s4)',
  },
  error: {
    marginBottom: 'var(--ebl-s3)',
  },
  userFriendlyError: {
    marginBottom: 'var(--ebl-s3)',
    fontWeight: 'var(--ebl-wf-body-weight)',
  },
  text: {
    fontWeight: 'var(--ebl-wf-body-weight)',
  },
  imageContainer: {
    flexBasis: '50%',
    maxWidth: '698px',
    transform: 'translateY(-2.5rem)',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  image: {
    width: '100%',
  },
  link: {
    whiteSpace: 'nowrap',
    '& span': {
      marginBottom: '0.125rem',
      marginLeft: 6,
    },
    [`&:visited`]: {
      color: 'var(--ebl-link-visited-color) !important',
    },
    [`&:visited > span > svg`]: {
      fill: 'var(--ebl-link-visited-color) !important',
    },
  },
}));
